import {
  Bar
} from "vue-chartjs";
import messages from "@/languages/index"
let language = localStorage.getItem('language') || store.state.language || "pt"

export default {
  name: "Home",
  extends: Bar,
  props: [
    "data",
    "labels",
    "max"
  ],
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [{
        label: messages[language].labelCurrency,
        backgroundColor: 'rgba(72,72,176,1)',
        data: [],
        // borderColor: "black",
        pointBackgroundColor: "white",
        borderWidth: 1,
        pointBorderColor: "white",
      },],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        // xAxes: [{
        //   ticks: {
        //     maxRotation: 90,
        //     minRotation: 80
        //   }
        // }],
        yAxes: [{
          ticks: {
            min: 0,
            max: 1000,
            stepSize: 20,
          }
        }]
      }
    },

    gradient: ''
  }),

  watch: {
    data(val) {
      val.map(item => {
        this.chartdata.datasets.map(set => {
          set.data.push(Number(item));
        });
      })
      this.renderChart(this.chartdata, this.options);
    },

    labels(val) {
      val.map(item => {
        this.chartdata.labels.push(item)
      });

      this.renderChart(this.chartdata, this.options);
    },

    max(val) {
      this.options.scales.yAxes[0].ticks.max = parseInt(val, 10);
      this.renderChart(this.chartdata, this.options);
    }

  },

  async mounted() {
    this.gradient = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 450)

    this.gradient.addColorStop(0, '#00e676')
    // this.gradient.addColorStop(0.5, 'rgba(0, 0, 0, 0.50)');
    this.gradient.addColorStop(1, '#00e676');


    this.chartdata.datasets.forEach(set => {
      set.backgroundColor = this.gradient;
    });
  },
};